import Modal from 'common/modal';

import PullReportData from './pull-report-data';

interface Props {
  estateId: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onPullReportDataComplete: Function;
  setShowModal: (value: boolean) => void;
  showModal: boolean;
}

export default function PullReportDataModal({
  estateId,
  setShowModal,
  showModal,
  onPullReportDataComplete,
}: Props) {
  const onExitClick = () => {
    setShowModal(false);
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <PullReportData
          estateId={estateId}
          onExitClick={onExitClick}
          onPullReportDataComplete={onPullReportDataComplete}
        />
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
}
